import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import React from "react";

interface TierSelectorProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
}

const TierSelector: React.FC<TierSelectorProps> = ({
  label,
  value,
  onChange,
  min = 0,
  max = 5,
  disabled = false,
}) => {
  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrement = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value) || 0;
    if (newValue >= min && newValue <= max) {
      onChange(newValue);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" sx={{ mb: 1, color: "text.secondary" }}>
        {label}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton
          size="small"
          onClick={handleDecrement}
          disabled={disabled || value <= min}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            width: 32,
            height: 32,
          }}
        >
          <RemoveIcon fontSize="small" />
        </IconButton>
        <TextField
          value={value}
          onChange={handleInputChange}
          disabled={disabled}
          inputProps={{
            min,
            max,
            style: { textAlign: "center" },
          }}
          size="small"
          sx={{
            width: 60,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "divider",
              },
            },
          }}
        />
        <IconButton
          size="small"
          onClick={handleIncrement}
          disabled={disabled || value >= max}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            width: 32,
            height: 32,
          }}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TierSelector;
